import type { BossConfig } from '../../entities/BossConfig';

export const BIG_BOAR_CONFIG: BossConfig = {
  id: 'big_boar',
  displayName: 'Большой Кабан',
  bossType: 'charging',

  maxHp: 60,
  speed: 0,
  movementBehavior: 'charging_boss',

  chargingParams: {
    idleMs: 1500,
    windupMs: 500,
    chargeSpeed: 400,
    recoveryMs: 1000,
    contactDamage: 1,
  },

  // Увеличено в 1.5 раза: 40→60 (исторически было 100, ÷2.5 → 40, теперь ×1.5).
  // Спрайт display height = 60 × 2 × scale = 120 px на 720p. Хитбокс 60×60.
  // Лужа смерти ~120 px (через recordEnemyPuddle с size).
  size: 60,
  // baseColor для Rectangle-плейсхолдера (виден только если overlay-спрайт не
  // загрузится). phaseTints НЕ задан — кабан всегда в натуральных цветах PNG,
  // без цветовых сдвигов по фазам.
  color: 0x6b3f1f,

  scoreReward: 500,
};
